import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ComputerIcon from '@mui/icons-material/Computer';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import Companies from 'src/pages/Companies';
import Dashboard from 'src/pages/Dashboard';
import HealthCheck from 'src/pages/HealthCheck';
import Settings from 'src/pages/Settings';
import Sites from 'src/pages/Sites';
import Solutions from 'src/pages/Solutions';
import Otp from 'src/pages/Otp';
import Users from 'src/pages/Users';
import Monitoring from 'src/pages/Monitoring';
import Alerts from 'src/pages/Alerts';
import AppStream from 'src/pages/AppStream';
import AppStreamRedirect from 'src/pages/AppStreamRedirect';
import OmniversePortal from 'src/omniverse';
import { AuthCallback, UserRole } from 'src/auth';
import { ReactComponent as CompaniesIcon } from 'src/assets/icons/companies.svg';
import { ReactComponent as DashboardIcon } from 'src/assets/icons/dashboard.svg';
import { ReactComponent as SolutionsIcon } from 'src/assets/icons/solutions_1.svg';
import { ReactComponent as OtpIcon } from 'src/assets/icons/otp.svg';
import { ReactComponent as SitesIcon } from 'src/assets/icons/site.svg';
import { ReactComponent as MonitorIcon } from 'src/assets/icons/monitoring.svg';
import AppSessionsList from 'src/pages/Solutions/SolutionAssetHierarchy/solutionAssetOmniverseApp/AppSessionsList';
import DefaultRedirect from './components/DefaultRedirect';
import * as ROUTES from './constants';
import { RootRouteProps } from './types';
import FooterRoutes from '../components/SideBar/router/SideBarFooter';

export const routes: RootRouteProps[] = [
  {
    path: ROUTES.DASHBOARD,
    component: Dashboard,
    exact: true,
    meta: {
      title: 'Dashboard',
      navLink: true,
      icon: DashboardIcon,
    },
  },
  {
    path: ROUTES.SOLUTIONS,
    component: Solutions,
    meta: {
      title: 'Solutions',
      description: 'Solutions list view, add new, etc.',
      dashboardLink: true,
      navLink: true,
      icon: SolutionsIcon,
    },
  },
  {
    path: ROUTES.OTP,
    component: Otp,
    meta: {
      title: 'OTP Management',
      description: 'otps list view, add new, etc.',
      dashboardLink: true,
      navLink: true,
      icon: OtpIcon,
    },
  },
  {
    path: ROUTES.USERS,
    component: Users,
    meta: {
      title: 'Users',
      description: 'Users list view',
      dashboardLink: true,
      navLink: true,
      icon: GroupOutlinedIcon,
    },
  },
  {
    path: ROUTES.MONITORING,
    component: Monitoring,
    meta: {
      title: 'Monitoring',
      description: 'Dashboard list  ',
      dashboardLink: true,
      navLink: true,
      icon: MonitorIcon,
    },
  },
  {
    path: ROUTES.ALERTS,
    component: Alerts,
    allowedUserRoles: [
      UserRole.PlatformOwner,
      UserRole.PlatformEngineer,
      UserRole.PlatformReader,
    ],
    meta: {
      title: 'Alerts',
      description: 'Alerts list, Incident list, etc',
      dashboardLink: true,
      navLink: true,
      icon: WarningAmberIcon,
    },
  },
  {
    path: ROUTES.SETTINGS,
    component: Settings,
    meta: {
      title: 'Settings',
      description: 'Change user personal settings',
      dashboardLink: true,
      disabled: true,
      navLink: true,
      icon: SettingsOutlinedIcon,
    },
  },
  {
    path: ROUTES.COMPANIES,
    component: Companies,
    meta: {
      title: 'Companies',
      description: 'Companies list view, add new, etc.',
      dashboardLink: true,
      navLink: true,
      icon: CompaniesIcon,
    },
  },
  {
    path: ROUTES.SITES,
    component: Sites,
    meta: {
      title: 'Sites',
      description: 'Sites List, Add New, Edit',
      dashboardLink: true,
      navLink: true,
      icon: SitesIcon,
    },
  },
  {
    path: '',
    component: FooterRoutes,
  },
  {
    path: ROUTES.HEALTH_CHECK,
    component: HealthCheck,
    isPublic: true,
  },
  {
    path: ROUTES.LOGIN_CALLBACK,
    component: AuthCallback,
    isPublic: true,
  },
  {
    path: ROUTES.ROOT,
    component: DefaultRedirect,
    exact: true,
  },
  {
    path: ROUTES.APP_STREAM,
    component: AppStream,
    meta: {
      title: 'Application Stream',
      description: 'Interactive application streaming',
      icon: ComputerIcon,
    },
  },
  {
    path: ROUTES.APP_STREAM_REDIRECT,
    component: AppSessionsList,
    meta: {
      title: 'Application Sessions',
      description: 'View and manage active application sessions',
      icon: ComputerIcon,
    },
  },
  {
    path: ROUTES.OMNIVERSE,
    component: OmniversePortal,
    meta: {
      title: 'Simulation',
      description: 'OV on DGX Cloud',
      dashboardLink: false, // This route is not shown on the dashboard
      navLink: false, // This route is not shown in the main navigation
      icon: ViewInArIcon,
    },
  },
];
